import React, { useEffect, useRef, useContext, useState } from "react";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { ASSETS_URL, store } from "../../../Store";

import { DropdownCuentaIndividual } from "./DropdownCuentaIndividual";
import { useIndividualHeaderDropdown } from "../../../../hooks/header/useIndividualHeaderDropdown";
import { useAccessibility } from "../../../../hooks/useAccessibility";
import { NotificationButton } from "../../components/notification-button";
import { LangButton } from "../../../language/lang-button";
import { AccesibilidadContext } from "../../../../contexts/AccesibilidadContext";
/**
 * Componente con las opciones del header individual
 * @param {object} textosInterfaz - contiene los textos de interfaz
 * @returns {JSX.Element} NavbarNav
 */
export const NavbarNav = ({ textosInterfaz }) => {

    const globalState = useContext(store);
    const { state } = globalState;
    const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    const showADropdown = useIndividualHeaderDropdown();
    const visible = showADropdown?.state?.visible;
    const dropdownButtonRef = useRef(null);

    const [accOver, setAccOver] = useState(false);

    const [esTemaClasico, setEsTemaClasico] = useState(true);
    const accebilidadState = useContext(AccesibilidadContext);
    const location = useLocation();

    /*Asigna el botón que abre el dropdown del header individual */
    useEffect(() => {
        if (dropdownButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "individualHeaderDropdown.triggerButtonRef",
                value: dropdownButtonRef,
            });
        }
    }, [dropdownButtonRef.current]);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);

    /*cierra el dropdown al hacer scroll al inicio de la página */
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                showADropdown.setVisible(false)
            }
        });
    }, [accessibility.state.visible])

    /*Actualiza el estado de EsTemaClasico. */
    useEffect(() => {
        let tema = accebilidadState?.temaActual !== 'clasico' ? false : true;
        setEsTemaClasico(tema);
    }, [accebilidadState])

    return (
        <ul className="option-nav d-flex justify-content-end aling-items-center">
            <li className="position-relative">
                <div className="wrapper-cuenta">
                    <button
                        ref={dropdownButtonRef}
                        className={`d-flex justify-content-center align-items-center  focusable-red ${visible && 'openMode'}  ${location.pathname.includes('/mi-panel') || location.pathname === '/favoritos' ? "btn-header-general activeMode" : "btn-header-general"}`}
                        onClick={() => {
                            showADropdown.setVisible(!showADropdown?.state?.visible);
                        }}
                    >
                        <div
                            className="mr-1 mr-lg-3 btn-avatar"
                            style={
                                { backgroundImage: `url('${isLogged ? `${ASSETS_URL}${state.datosHeader?.avatar}` : '/img/profile.png'}')` }
                            }
                        ></div>
                        <span>{textosInterfaz?.mi_cuenta || 'Mi cuenta'}</span>
                        <i className="fas fa-chevron-down fa-sm ml-2 arrow"></i>
                    </button>
                </div>

                <DropdownCuentaIndividual textosInterfaz={textosInterfaz} />

            </li>
            <li className={`ml-2`}>
                <button
                    ref={accessibilityButtonRef}
                    aria-label="Ajustes -Settings"
                    className={`focusable-red ${accessibility.state.visible ? 'icon-button activeMode' : 'icon-button'} `}
                    onClick={() => { accessibility.setVisible(!accessibility?.state?.visible) }}
                    onMouseOver={() => setAccOver(true)}
                    onMouseLeave={() => setAccOver(false)}
                    style={{
                        color: isLogged ?
                            (accOver || accessibility?.state?.visible) ?
                                "var(--onprimary-inverse)"
                                :
                                esTemaClasico ?
                                    state.datosHeader?.colorLetra !== null ?
                                        state.datosHeader?.colorLetra
                                        :
                                        'var(--onsecondary-color)'
                                    :
                                    "var(--primary-inverse)"
                            :
                            "",
                        background: isLogged ? (accOver || accessibility?.state?.visible) ? "var(--primary-inverse)" : "" : ""
                    }}
                >
                    <Icon
                        /* icon="material-symbols:settings" */
                        icon="la:universal-access"
                        width="30" height="30"
                    />
                </button>
            </li>

            <NotificationButton />

            <li>
                <LangButton />
            </li>

        </ul>
    )
}